import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import * as Styled from "../Login/style";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import HttpApis from "../../services/HttpApis";
import Loader from "../loader/Loader";
import { Notyf } from "notyf";
import "notyf/notyf.min.css";
import { MdKeyboardArrowLeft } from "react-icons/md";
import { useTenant } from "../../TenantContext";

const ChangePassword = () => {
  const { logo } = useTenant();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [error, setError] = useState("");
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const notyf = new Notyf({ position: { x: "center", y: "center" } });

  useEffect(() => {
    try {
      const persistRoot = localStorage.getItem("persist:root");
      if (persistRoot) {
        const parsed = JSON.parse(persistRoot);
        const authReducer = JSON.parse(parsed.authReducer);
        const userEmail = authReducer?.user?.data?.user?.email;
        if (userEmail) {
          setEmail(userEmail);
          localStorage.setItem("changePasswordEmail", userEmail);
        }
      } else {
        const storedEmail = localStorage.getItem("changePasswordEmail");
        if (storedEmail) {
          setEmail(storedEmail);
        }
      }
    } catch (e) {
      console.error("Error getting email from localStorage:", e);
      const storedEmail = localStorage.getItem("changePasswordEmail");
      if (storedEmail) {
        setEmail(storedEmail);
      }
    }
  }, []);

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleSubmit();
    }
  };

  const handleSubmit = async () => {
    setError("");

    if (!currentPassword || !newPassword) {
      setError("Please fill in all fields");
      return;
    }

    try {
      setLoading(true);
      await HttpApis.changePassword({
        email: email,
        current_password: currentPassword,
        new_password: newPassword
      });

      notyf.success("Password changed successfully");
      localStorage.removeItem("changePasswordEmail");

      setTimeout(() => {
        navigate("/home");
      }, 2000);
    } catch (err) {
      setError(err.response?.data?.message || err.message || "Failed to change password");
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <Styled.LoginContainer>
      <Styled.MainContainer className="container">
        <div className="logo-container">
          <img src={logo} alt="Logo" className="logo" />
        </div>
        <div className="formContainer">
          <p className="para">Change your password</p>
          <input
            placeholder="Email"
            className="inputBox"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            onKeyDown={handleKeyDown}
            disabled={true}
            style={{ opacity: 0.6, cursor: "not-allowed" }}
          />
          <Styled.PasswordContainer>
            <input
              placeholder="Current Password"
              type={showCurrentPassword ? "text" : "password"}
              className="inputBox"
              value={currentPassword}
              onChange={(e) => {
                setCurrentPassword(e.target.value);
                setError("");
              }}
              onKeyDown={handleKeyDown}
            />
            <span className="eyeIcon" onClick={() => setShowCurrentPassword(!showCurrentPassword)}>
              {showCurrentPassword ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
            </span>
          </Styled.PasswordContainer>
          <Styled.PasswordContainer>
            <input
              placeholder="New Password"
              type={showNewPassword ? "text" : "password"}
              className="inputBox"
              value={newPassword}
              onChange={(e) => {
                setNewPassword(e.target.value);
                setError("");
              }}
              onKeyDown={handleKeyDown}
            />
            <span className="eyeIcon" onClick={() => setShowNewPassword(!showNewPassword)}>
              {showNewPassword ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
            </span>
          </Styled.PasswordContainer>
          {error && <p className="errorText">{error}</p>}
          <Button
            className="btn"
            onClick={handleSubmit}
            style={{ backgroundColor: "var(--brand, #B87333)", borderColor: "var(--brand, #B87333)" }}
          >
            Submit
          </Button>
        </div>
        <div className="paraText clickable" onClick={() => {
          navigate("/accountPage", { state: { tab: "setting" } })
        }} style={{ cursor: "pointer" }}>
          <span><MdKeyboardArrowLeft className="arrowIcon" /></span> Go Back
        </div>
      </Styled.MainContainer>
    </Styled.LoginContainer>
  );
};

export default ChangePassword;
